<script>
  import { onMount } from "svelte";
  import { editStepNotes } from "../static";
  import FlowSteps from "./FlowSteps.svelte";
  import {External, M} from "../../external";

  export let data;
  export let onClick;
  export let onRemove;
  export let onMoveUp;
  export let onMoveDown;
  export let automation;
  export let automationSave;

  let block = null,
    leftWing = null,
    rightWing = null,
    blockWidth = 0,
    leftWingWidth = 0,
    rightWingWidth = 0,
    leftWingArrowWidth = 0,
    leftWingArrowX = 0,
    rightWingArrowWidth = 0,
    rightWingArrowX = 0;

  let defaultNote = "";

  if (!data) {
    data = {};
  }

  data.waiting = data.waiting || 0;
  data.completed = data.completed || 0;
  data.opened = data.opened || 0;
  data.clicked = data.clicked || 0;

  onMount(function () {
    setDefaultNote();
  });

  function editNotes() {
    editStepNotes(data.stickyNotes, (notes) => {
      data.stickyNotes = notes;
      External.CPanel.setChanged(true);
      setDefaultNote();
    });
  }

  function setDefaultNote() {
    defaultNote = "";
    if (data && data.stickyNotes) {
      for (let note of data.stickyNotes) {
        defaultNote = note.active ? note.message : defaultNote;
      }
    }
  }

  let icon = "error_outline";
  let message = M.ERROR;
  let title = M.ERROR;
  let automationRule = "";
  let split = "";
  let hasWaiting = false;
  let hasOpened = false;
  let hasClicked = false;
  let name = '';

  $: {
    name = data.name || '';
    if (!icon || !data || !data.type) {
      icon = "error_outline";
      message = M.ERROR;
      title = M.ERROR;
    }

    switch (data.type) {
      case "DELAY":
        icon = "schedule";
        title = M.DELAY;
        automationRule = "automation-rule";
        message = M.DELAY_DESC;
        hasWaiting = true;
        if (data.settings && data.settings.length) {
          let settings = data.settings[0];
          if (settings.key === 'exact') {
            name = External.Tools.dateToString(new Date(+settings.value), true, true);
          }
        }
        break;
      case "IF_ELSE":
        icon = "help_outline";
        title = M.IFELSE;
        automationRule = "automation-rule";
        split = "if-automation";
        message = M.IFELSE_DESC;
        break;
      case "SPLIT":
        icon = "call_split";
        title = M.SPLIT;
        automationRule = "automation-rule reverse-icon";
        split = "if-automation";
        message = M.SPLIT_DESC;
        break;
      case "TARGET":
        icon = "flag";
        title = M.TARGET;
        automationRule = "automation-rule";
        message = M.TARGET_DESC;
        break;
      case "SEND_EMAIL":
        icon = "mail_outline";
        title = M.SEND_EMAIL;
        message = "";
        // hasOpened = true;
        // hasClicked = true;
        break;
      case "SEND_EMAIL_NOTIFICATION":
        icon = "notification_important";
        title = M.SEND_EMAIL_NOTIFICATION;
        message = "";
        break;
      case "SEND_SMS":
        icon = "sms";
        title = M.SEND_SMS;
        message = "";
        break;
      case "SEND_WHATSAPP":
        icon = "whatsapp";
        title = M.SEND_WHATSAPP;
        message = "";
        break;
      case "SEND_VOICE":
        icon = "voice_chat";
        title = M.SEND_VOICE;
        message = "";
        break;
      case "CONTACT_TAG_ADD":
        icon = "label";
        title = M.CONTACT_TAG_ADD;
        message = M.CONTACT_TAG_ADD_DESC;
        break;
      case "CONTACT_TAG_REMOVE":
        icon = "label_off";
        title = M.CONTACT_TAG_REMOVE;
        message = M.CONTACT_TAG_REMOVE_DESC;
        break;
      case "CONTACT_PROPERTY_CHANGE":
        icon = "assignment_ind";
        title = M.CONTACT_PROPERTY_CHANGE;
        message = M.CONTACT_PROPERTY_CHANGE_DESC;
        break;
      case "CONTACT_NOTE_ADD":
        icon = "sticky_note_2";
        title = M.CONTACT_NOTE_ADD;
        message = M.CONTACT_NOTE_ADD_DESC;
        break;
      case "CONTACT_DELETE":
        icon = "person_remove";
        title = M.CONTACT_DELETE;
        message = M.CONTACT_DELETE_DESC;
        break;
      case "CONTACT_LIST_ADD":
        icon = "person_add";
        title = M.CONTACT_LIST_ADD;
        message = M.CONTACT_LIST_ADD_DESC;
        break;
      case "CONTACT_LIST_REMOVE":
        icon = "person_remove";
        title = M.CONTACT_LIST_REMOVE;
        message = M.CONTACT_LIST_REMOVE_DESC;
        break;
      case "CONTACT_MEMBER_GROUP_ADD":
        icon = "person_add";
        title = M.CONTACT_MEMBER_GROUP_ADD;
        message = M.CONTACT_MEMBER_GROUP_ADD_DESC;
        break;
      case "CONTACT_MEMBER_GROUP_REMOVE":
        icon = "person_remove";
        title = M.CONTACT_MEMBER_GROUP_REMOVE;
        message = M.CONTACT_MEMBER_GROUP_REMOVE_DESC;
        break;
      case "CONTACT_UNSUBSCRIBE":
        icon = "person_remove";
        title = M.CONTACT_UNSUBSCRIBE;
        message = M.CONTACT_UNSUBSCRIBE_DESC;
        break;
      case "START_AUTOMATION":
        icon = "autorenew";
        title = M.OTHER_ANOTHER_START;
        message = M.OTHER_ANOTHER_START_DESC;
        break;
      case "END_AUTOMATION":
        icon = "exit_to_app";
        title = "End This Automation";
        message = "";
        break;
      case "TRIGGER_WEBHOOK":
        icon = "link";
        title = M.OTHER_WEBHOOK_TRIGGER;
        message = "";
        break;
      case "CONTACT_LMS_ENROLL":
        icon = "input";
        title = M.ACTION_ENROLL_TO_CIRCLE;
        message = "";
        break;
      case "CONTACT_LMS_UNENROLL":
        icon = "output";
        title = M.ACTION_UNENROLL_FROM_CIRCLE;
        message = "";
        break;
      default:
        icon = "error_outline";
        title = M.ERROR;
        message = M.ERROR;
        break;
    }
  }

  $: {
    if (block && leftWing && rightWing) {
      let blockBox = block.getBoundingClientRect();
      let leftWingBox = leftWing.getBoundingClientRect();
      let rightWingBox = rightWing.getBoundingClientRect();

      leftWingArrowWidth = blockWidth / 2 + blockBox.x - leftWingBox.x - leftWingWidth / 2;
      rightWingArrowWidth = rightWingBox.x + rightWingWidth / 2 - blockBox.width / 2 - blockBox.x;

      leftWingArrowX = blockWidth / 2 - leftWingArrowWidth;
      rightWingArrowX = blockWidth / 2;
    }
  }
</script>

<div class="automation-row mt-15 mb-15">
  <div class="automation-action {split}" on:click={onClick}>
    <div class="automation-icon flex align-center justify-center {automationRule}">
			{#if icon === 'whatsapp'}
				<svg style="width: 26px; height: 26px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 124 124" viewBox="0 0 124 124" id="whatsapp"><path fill="#ffffff" fill-rule="evenodd" d="M64,15.8c-25.5,0-46.2,20.7-46.2,46.2c0,9,2.5,17.6,7.4,25.1l-7,15.5 c-0.6,1.4-0.4,3.1,0.6,4.3c0.8,0.9,1.9,1.4,3.1,1.4c0.4,0,0.7,0,1.1-0.1l19.4-5.3c6.7,3.6,14.2,5.5,21.8,5.5 c25.5,0,46.2-20.7,46.2-46.2C110.2,36.5,89.5,15.8,64,15.8z M64,100.2c-6.8,0-13.4-1.8-19.2-5.2c-0.6-0.4-1.3-0.6-2-0.6 c-0.4,0-0.7,0-1.1,0.1L29,98l4.4-9.7c0.6-1.3,0.4-2.9-0.4-4c-4.7-6.5-7.2-14.2-7.2-22.3C25.8,41,43,23.8,64,23.8 c21,0,38.2,17.1,38.2,38.2C102.2,83,85.1,100.2,64,100.2z" clip-rule="evenodd"></path><path fill="#ffffff" fill-rule="evenodd" d="M81.8,68.9c-1.9-1.2-4.5-2.5-6.7-1.5c-1.7,0.7-2.9,3.5-4,4.9c-0.6,0.7-1.3,0.8-2.2,0.5 c-6.6-2.6-11.6-7-15.2-13c-0.6-0.9-0.5-1.7,0.2-2.6c1.1-1.3,2.5-2.8,2.8-4.5c0.3-1.7-0.5-3.8-1.2-5.3c-0.9-2-1.9-4.8-3.9-5.9 c-1.8-1-4.2-0.5-5.8,0.9c-2.8,2.3-4.2,5.9-4.1,9.4c0,1,0.1,2,0.4,3c0.6,2.3,1.6,4.5,2.9,6.6c0.9,1.6,1.9,3.1,3,4.5 c3.5,4.8,7.9,8.9,12.9,12c2.5,1.5,5.3,2.9,8.1,3.8c3.2,1,6,2.1,9.4,1.5c3.6-0.7,7.1-2.9,8.5-6.3c0.4-1,0.6-2.2,0.4-3.2 C86.6,71.3,83.6,70,81.8,68.9z" clip-rule="evenodd"></path></svg>
			{:else if icon === 'voice_chat'}
				<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M240-520h60v-80h-60v80Zm100 80h60v-240h-60v240Zm110 80h60v-400h-60v400Zm110-80h60v-240h-60v240Zm100-80h60v-80h-60v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"></path></svg>
			{:else}
				<span class="material-icons-outlined"> {icon} </span>
			{/if}
    </div>
    <div class="automation-content">
      <h6>{title}</h6>
      {#if name}
        <h5>{name}</h5>
      {/if}
      <div class="automation-visitors">
        {#if hasWaiting}
          <span><b>{data.waiting}</b> {M.WAITING}</span>
        {/if}
        <span><b>{data.completed}</b> {M.COMPLETED}</span>
        {#if hasOpened}
          <span><b>{data.opened}</b> {M.OPENED}</span>
        {/if}
        {#if hasClicked}
          <span><b>{data.clicked}</b> {M.CLICKED}</span>
        {/if}
      </div>
    </div>
    <div class="automation-notes flex" style="font-family: 'Caveat';">
      <a on:click|stopPropagation={editNotes} class="automation-notes-icon flex-none {defaultNote ? 'red' : ''} rounded-effect" title="Notes"
        ><span class="material-icons-outlined"> sticky_note_2 </span></a>
      <span on:click|stopPropagation={editNotes} class="last-automation-note">{defaultNote}</span>
    </div>
    <div class="automation-step-controls">
      <a on:click|stopPropagation={onRemove} title="Delete Step">
        <span class="material-icons-outlined"> delete </span>
      </a>
      <div class="automation-step-controls-inner">
        {#if onMoveUp}
          <a on:click|stopPropagation={onMoveUp} title="Move Step Up">
            <span class="material-icons up-arrow"> arrow_right_alt </span>
          </a>
        {:else}
          <a>
            <span class="material-icons up-arrow ui-state-disabled" title="Move Step Up"> arrow_right_alt </span>
          </a>
        {/if}
        {#if onMoveDown}
          <a on:click|stopPropagation={onMoveDown}>
            <span class="material-icons down-arrow" title="Move Step Down"> arrow_right_alt </span>
          </a>
        {:else}
          <a>
            <span class="material-icons down-arrow ui-state-disabled" title="Move Step Down"> arrow_right_alt </span>
          </a>
        {/if}
      </div>
    </div>
    {#if split}
      <div class="yes-no-wrapper flex align-center justify-center">
        <div class="pay-status paid">{M.YES}</div>
        <div class="order-status pending">{M.NO}</div>
      </div>
    {/if}
  </div>
</div>
{#if split}
  <div class="automation-block" bind:clientWidth={blockWidth} bind:this={block}>
    <div class="automation-row mb-15 split-row mt-15">
      <div class="automation-wing" bind:clientWidth={leftWingWidth} bind:this={leftWing}>
        <FlowSteps bind:data={data.subflowA} automation={automation} automationSave={automationSave} />
      </div>
      <div class="automation-wing" bind:clientWidth={rightWingWidth} bind:this={rightWing}>
        <FlowSteps bind:data={data.subflowB} automation={automation} automationSave={automationSave} />
      </div>
    </div>
    <div class="automation-wing-arrow" style="width: {leftWingArrowWidth}px; left: {leftWingArrowX}px;">
      <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M 0,100 C 0,0 100,100 100,0" />
      </svg>
    </div>
    <div class="automation-wing-arrow" style="width: {rightWingArrowWidth}px; left: {rightWingArrowX}px;">
      <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M 100,100 C 100,0 0,100 0,0" />
      </svg>
    </div>
  </div>
{/if}
